import { Availability } from './availability';

export interface Address {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postal: string;
  phone: string;
}

export class Site {
  name: string;
  address: Address;
  isKioskClosed: boolean;
  workingHours: Availability[];
  storeId: string;
  taxNumber: string;

  constructor(
    name: string,
    address: Address,
    isKioskClosed: boolean,
    workingHours: Availability[],
    storeId: string,
    taxNumber: string,
  ) {
    this.name = name;
    this.address = address;
    this.isKioskClosed = isKioskClosed;
    this.workingHours = workingHours;
    this.storeId = storeId;
    this.taxNumber = taxNumber;
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
